export const MOBILE_RECOMMENDATION_COUNT = 3;
